import React, { Component } from 'react';
import TextAndImage from "./../../alpineComponents/textAndImage";
import ScrollFadeIn from "./../scrollFadeIn";

export default class BookList extends Component {
  render() {
    return (
      <div>
        <ScrollFadeIn>
          <div className="small-padding">
            <div className="max-width-container">
              <TextAndImage
                ratio={"square"}
                direction={"right"}
                resizeMode={"contain"}
                image="/images/grumple-cover.png"
                title={'A Tahoe tale of Kindness'}
                description={`Join Grumple, your not-so-average bear, on his journey to become the best in all the woods. Through a series of surprisingly silly misadventures, Grumple discovers that being the best isn't always about being the greatest, the fastest, the busiest, or even the stinkiest, but rather, the kindest. Find out how this bear fares as he attempts to make a bigger-than-big impact on the woods around him in this terrific tale of kindness.`}
                buttonText={'Meet Grumple!'}
                buttonLink={'/grumple'}
              />
            </div>
          </div>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <div className="small-padding">
            <div className="max-width-container">
              <TextAndImage
                ratio={"square"}
                resizeMode={"contain"}
                image="/images/book-cover-stack.jpg"
                title={'Live your best life, no matter where you are'}
                description={`The Joys of Jet Lag is your guidebook to using a traveler's mindset to navigate a life of joy. By breaking free from asshole-autopilot, you'll reawaken to the wonder around you, embrace challenges as part of the adventure, and trust that life is always happening for you, not to you. With captivating travel stories, simple exercises, and refreshingly real self-help advice without any of the rah-rah, this hilarious how-to guide will help you discover the keys to living your best life with no passport required.`}
                buttonText={'Get More Joy!'}
                buttonLink={'/joys'}
              />
            </div>
          </div>
        </ScrollFadeIn>
      </div>
    );
  }
}
  
  
  


// WEBPACK FOOTER //
// ./src/components/bookList/index.js